<template>
  <!-- The height makes room for the md/lg scale-up, which does not take up layout space. -->
  <div
    class="p-[16px] md:p-[20px] lg:p-[24px]"
    :class="
      showTotal ? 'h-[231px] md:h-[300px] lg:h-[380px]' : 'h-[192px] md:h-[240px] lg:h-[288px]'
    "
  >
    <div class="flex justify-center">
      <div class="relative scale-[1] md:scale-[1.25] lg:scale-[1.5]">
        <circle-progress
          :percent="progress"
          :fill-color="'#FEC629'"
          :empty-color="'#FFFFFF'"
          :linecap="'straight'"
          :size="160"
          :border-width="16"
          :border-bg-width="16"
          :transition="0"
        />
        <div class="absolute inset-0 flex flex-col items-center justify-center text-[#191817]">
          <div
            class="text-[0.875rem] leading-[1.25rem] font-normal text-center whitespace-pre-line"
          >
            {{ label }}
          </div>
          <div class="text-[1rem] leading-[1.5rem] font-bold text-center">
            {{ formattedAmountFulfilled }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="showTotal" class="flex flex-row justify-between mt-[8px]">
      <div
        class="text-[0.875rem] md:text-[1rem] lg:text-[1.125rem] leading-[1.25rem] md:leading-[1.375rem] lg:leading-[1.5rem] font-normal"
      >
        Total pledge amount
      </div>
      <div
        class="text-[0.875rem] md:text-[1rem] lg:text-[1.125rem] leading-[1.25rem] md:leading-[1.375rem] lg:leading-[1.5rem] font-bold"
      >
        {{ formattedTotalPledgeAmount }}
      </div>
    </div>
  </div>
</template>
<script>
import 'vue3-circle-progress/dist/circle-progress.css';
import CircleProgress from 'vue3-circle-progress';
export default {
  components: {
    CircleProgress,
  },
  props: {
    totalPledgeAmount: {
      type: Number,
      default: 0,
    },
    amountFulfilled: {
      type: Number,
      default: 0,
    },
    // Inside the ring. A line break in it is kept.
    label: {
      type: String,
      default: 'Amount fulfilled',
    },
    // The "Total pledge amount" row under the ring.
    showTotal: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    // rounded to nearest whole number, capped at 100%
    progress() {
      if (!this.totalPledgeAmount) {
        return 0; //sets progress to 0 when not loaded, then sets to correct value when loaded
      }
      const result = Math.round((this.amountFulfilled / this.totalPledgeAmount) * 100);
      return Math.min(result, 100); // Cap at 100% even if fulfilled > pledged
    },
    formattedTotalPledgeAmount() {
      return `$${this.totalPledgeAmount.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
    },

    formattedAmountFulfilled() {
      return `$${this.amountFulfilled.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
    },
  },
};
</script>
